import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import JawsCorrectionApi from '../api/jawsCorrectionApi';
import { JawsCorrectionResponse, JawsCorrectionsBulkUploadPayload } from '@/schema/JawsCorrection';

// Fetch a single Jaws Correction by ID
export const useJawsCorrection = (id: string) => {
  return useQuery<JawsCorrectionResponse>({
    queryKey: ['jawsCorrection', id],
    queryFn: () => JawsCorrectionApi.getById(id),
  });
};

export const useJawsCorrections = (ids: string[], options?: { enabled?: boolean }) => {
  const sortedIds = [...ids].sort();
  return useQuery<JawsCorrectionResponse[]>({
    queryKey: ['jawsCorrections', sortedIds],
    queryFn: async () => {
      const corrections = await Promise.all(sortedIds.map((id) => JawsCorrectionApi.getById(id)));
      return corrections.sort((a, b) => a.treatmentWeek - b.treatmentWeek);
    },
    enabled: (options?.enabled ?? true) && sortedIds.length > 0,
  });
};

// Create a bulk set of Jaws Corrections (multipart upload)
export const useCreateJawsCorrections = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: JawsCorrectionsBulkUploadPayload) =>
      JawsCorrectionApi.createBulk(payload),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['scans'] });
    },
  });
};
